// extracted by mini-css-extract-plugin
export default {"matchRowContent":"tSyI1","matchRow":"PxfCb","innerLineContainer":"NVHUT","detailsCell":"J9dny","mainLineStakes":"npVUY"};